export var WeightUnitEnum;
(function (WeightUnitEnum) {
    WeightUnitEnum["OZ"] = "oz";
    WeightUnitEnum["LB"] = "lb";
    WeightUnitEnum["MG"] = "mg";
    WeightUnitEnum["G"] = "g";
    WeightUnitEnum["KG"] = "kg";
})(WeightUnitEnum || (WeightUnitEnum = {}));
//# sourceMappingURL=WeightUnitEnum.js.map